import React, { Component } from "react";
import PropTypes from "prop-types";
import { wrapComponent } from "../utils/container";
import { DialogActions, DialogContent, Button, Typography } from "material-ui";
import Dialog from "../components/MobileScrollingDialog";
import withMobileDialog from "material-ui/Dialog/withMobileDialog";
import {
    submitCorrection,
    updateCorrection
} from "../actions/correction.actions";
import CorrectionTextEdit from "../components/CorrectionTextEdit";
import CorrectionToolbar from "../components/CorrectionToolbar";
import CommentEditor from "../components/CommentEditor";
import { validateCommentText } from "../utils/validation";
import { red } from "material-ui/colors/index";

const styleSheet = theme => ({
    mainContainer: {
        minWidth: 400,
        maxWidth: 960,
        padding: theme.spacing.unit
    },
    appBar: {
        width: "100%",
        margin: theme.spacing.unit
    },
    "@media (min-width: 600px)": {
        appBar: {
            marginLeft: 0
        }
    },
    flex: {
        flex: 1
    },
    dialogContent: {
        paddingBottom: 1.5 * theme.spacing.unit
    },
    error: {
        color: red[500],
        marginTop: -2
    }
});

class NewCorrectionDialog extends Component {
    editor = null;

    onRedo = () => {
        if (this.editor) {
            this.editor.redo();
        }
    };

    onUndo = () => {
        if (this.editor) {
            this.editor.undo();
        }
    };

    onRevertSelection = () => {
        if (this.editor) {
            this.editor.revertSelection();
        }
    };

    isComment() {
        const { correction: { body } } = this.props;
        return !body;
    }

    isEdit() {
        const { correction: { id } } = this.props;
        return !!id;
    }

    onCommentEditorChange = text => {
        this.props.dispatch(
            updateCorrection({ correction: { comment: text } })
        );
    };

    onCorrectionEditorChange = () => {
        const { edits, originalText } = this.editor.getCorrection();
        this.props.dispatch(
            updateCorrection({
                correction: {
                    edits,
                    body: originalText
                }
            })
        );
    };

    renderDialogContent() {
        const {
            t,
            classes,
            correction: { body, edits, comment },
            userSettings: { avatarURL, displayName }
        } = this.props;

        let component;
        if (this.isComment()) {
            component = (
                <CommentEditor
                    placeholder={t("correctionDialog.Add a comment")}
                    onChange={this.onCommentEditorChange}
                    text={comment}
                    avatarURL={avatarURL}
                    displayName={displayName}
                />
            );
        } else {
            component = (
                <CorrectionTextEdit
                    ref={c => {
                        this.editor = c;
                    }}
                    onChange={this.onCorrectionEditorChange}
                    body={body}
                    edits={edits}
                    readOnly={false}
                />
            );
        }

        return (
            <DialogContent className={classes.dialogContent}>
                {component}
            </DialogContent>
        );
    }

    componentDidUpdate(prevProps) {
        if (this.editor && !prevProps.open && this.props.open) {
            if (this.editor) {
                this.editor.focus();
            }
        }
    }

    handleRequestClose = () => {
        this.props.onRequestClose();
    };

    submitCorrection = () => {
        let { correction, dispatch } = this.props;
        if (this.editor) {
            const { edits, originalText } = this.editor.getCorrection();
            correction = correction.merge({
                edits,
                body: originalText
            });
        }
        dispatch(submitCorrection({ correction }));
    };

    renderDialogActions() {
        const {
            t,
            createRequest: { requesting },
            correction,
            classes
        } = this.props;
        const isComment = this.isComment();
        let valid = true,
            error;

        if (isComment) {
            const validation = validateCommentText(correction.comment);
            valid = validation.valid;
            error = validation.error;
        }

        const submitButton = (
            <Button
                onClick={this.submitCorrection}
                disabled={requesting || !valid}>
                {t("correctionDialog.Submit")}
            </Button>
        );

        const closeButton = (
            <Button onClick={this.handleRequestClose}>
                {t("correctionDialog.Close")}
            </Button>
        );

        return (
            <DialogActions>
                {error &&
                    <Typography className={classes.error} type="body1">
                        {error}
                    </Typography>}
                {closeButton}
                {submitButton}
            </DialogActions>
        );
    }

    renderDialogTitle() {
        const { t } = this.props;
        const isEdit = this.isEdit();
        const isComment = this.isComment();
        let title;

        if (isComment) {
            return;
        }
        if (isEdit) {
            title = t("correctionDialog.Edit correction");
        } else {
            title = t("correctionDialog.Add correction");
        }
        return (
            <CorrectionToolbar
                title={title}
                onRedo={this.onRedo}
                onUndo={this.onUndo}
                onRevertSelection={this.onRevertSelection}
            />
        );
    }

    render() {
        const { fullScreen, open } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                open={open}
                ignoreBackdropClick={true}
                onClose={this.handleRequestClose}>
                {this.renderDialogTitle()}
                {this.renderDialogContent()}
                {this.renderDialogActions()}
            </Dialog>
        );
    }
}

NewCorrectionDialog.propTypes = {
    open: PropTypes.bool,
    onRequestClose: PropTypes.func,
    dispatch: PropTypes.func.isRequired,
    classes: PropTypes.object,
    fullScreen: PropTypes.bool,
    createRequest: PropTypes.object.isRequired,
    correction: PropTypes.object.isRequired,
    userSettings: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired
};

function mapStateToProps({
    userSettings,
    createEditCorrection: { createRequest, correction }
}) {
    return {
        userSettings,
        correction,
        createRequest
    };
}

export default withMobileDialog({ breakpoint: "xs" })(
    wrapComponent(NewCorrectionDialog, styleSheet, mapStateToProps)
);



// WEBPACK FOOTER //
// ./src/containers/NewCorrectionDialog.jsx